"use client"
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__ from "@radix-ui/react-label";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
function Label({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__.Root, {
        "data-slot": "label",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("flex items-center gap-1 text-sm text-foreground leading-none select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", className),
        ...props
    });
}
export { Label };
